const isMainnet = process.env.IS_MAINNET === "true";
export const TENET_CALCULATOR_ADDRESS = isMainnet ? '0xC9095422362839A2226f749319D8dcEb2A3BA8fc' : '0xe44C8bd67670087a7A829Ab677E7d1b2c70C3724';
export const TENET_CALCULATOR_ADDRESS_ETH = isMainnet ? '0xC9095422362839A2226f749319D8dcEb2A3BA8fc' : '0xC98A5AC038b72693e0817ABa14cEe367614FcF94';
